import React from "react"
import { useLang } from "hooks/useLang"
import useWindowSize from "hooks/useWindowSize"

interface SectionTitleProps {
    title: string
    className?: string
}

const SectionTitle: React.FC<SectionTitleProps> = ({ title, className }) => {
    const { t } = useLang()
    const { isDesktop } = useWindowSize()

    return (
        <div className={`${isDesktop ? "sticky top-4" : ""} ${className}`}>
            <h6 className="lg:px-2 font-bold uppercase  md:mb-0">
                {t(title)}
            </h6>
        </div>
    )
}

export default SectionTitle
